import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={3}
    height={12}
    fill="none"
    viewBox="0 0 3 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.338 8.075a.84.84 0 0 1-.616-.25.83.83 0 0 1-.253-.615v-5.5q0-.363.249-.614a.83.83 0 0 1 .61-.25q.363 0 .616.25a.83.83 0 0 1 .254.614v5.5a.84.84 0 0 1-.25.614.83.83 0 0 1-.61.25m0 3.08a.85.85 0 0 1-.616-.25.82.82 0 0 1-.253-.61q0-.363.249-.616a.82.82 0 0 1 .61-.254q.363 0 .616.25.254.25.254.61a.85.85 0 0 1-.25.616.82.82 0 0 1-.61.254"
    />
  </svg>
);
export default SvgExclamation;
